import React from 'react'
import * as Clipboard from '../../../utils/clipboard'
import { IconButton } from '@material-ui/core'
import CopyIcon from '@material-ui/icons/LibraryBooks'
import Tooltip from '@material-ui/core/Tooltip/Tooltip'
import { strings } from '../../../localization/strings'

const Component = (props) => {
    var color = props.color ? props.color : 'inherit'
    var width = props.width ? props.width : 24
    var height = props.height ? props.height : 24

    return (
        <Tooltip title={strings.copyTooltip}>
            <IconButton
                onClick={() =>
                    Clipboard.copyText(
                        props.text,
                        () => {
                            if (props.onSuccess) props.onSuccess()
                        },
                        () => {
                            if (props.onFailed) props.onFailed()
                        }
                    )
                }
            >
                <CopyIcon
                    color={color}
                    style={{ width: width, height: height }}
                />
            </IconButton>
        </Tooltip>
    )
}

export default Component
